// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"e90b796a6db36b75a481","293":"a9f7ab63b9faa425328a"}[chunkId] + ".js";
};